import React from 'react'
import Panel from '../../containers/panel'
import { withGridContext } from '../providers'
import TableFilters from '../table-filters'
import { ContextType } from '../types/advanced-grid.types'
import TableFooter from '../table-footer/index'
import ButtonGroup from '../../button-group'
import TableLoader from '../table-loader'

interface Props {
    children?: React.ReactNode
}

const TableWrapper: React.FC<Props & ContextType> = ({
    children,
    buttons,
    config,
    dataLoaded,
    title
}) => {
    const { bordered, hover, striped } = config || {}
    const availableClasses = {
        'table-bordered': bordered,
        'table-striped': striped,
        'table-hover': hover
    }
    const classes = Object.keys(availableClasses)
        .reduce((a, c) => {
            if (availableClasses[c] === true) a.push(c)
            return a
        }, [] as string[])
        .join(' ')
    return (
        <Panel title={title}>
            {Boolean(buttons) && (
                <div className="mb-4 pl-1">
                    <ButtonGroup buttons={buttons || []} />
                </div>
            )}
            <TableFilters />
            {!dataLoaded && <TableLoader columns={6} rows={20} />}
            {dataLoaded && <table className={`table table-sm ${classes}`}>{children}</table>}
            <TableFooter />
        </Panel>
    )
}

export default React.memo(withGridContext(TableWrapper))
